<template>
  <app-layout title="AttendanceSetting">
    <DxScrollView width="100%" height="100%" class="px-4">
      <!-- Add padding on both sides -->
      <BsOnBoardForm
        :routeDef="this.routeDef"
        :createDef="this.billingDef"
        :modelData="modelData"
        :slug="slug"
        ref="onboardformRenderer"
      />
    </DxScrollView>

    <div class="flex justify-center mt-4">
      <!-- Center the button -->
      <DxButton
        :width="120"
        text="Save Attendance"
        type="default"
        styling-mode="contained"
        @click="saveRecord($event)"
      />
    </div>
  </app-layout>
</template>
  
  <script>
import AppLayout from "@/Layouts/AppLayout.vue";
import DxDateBox from "devextreme-vue/date-box";
import DxButton, { DxButtonTypes } from "devextreme-vue/button";
import BsOnBoardForm from "@include/forms/BsOnBoardForm";
import { DxScrollView } from "devextreme-vue/scroll-view";

export default {
  props: {
    productId: String,
    organisationId: String,
    subscriptionPlanId: String,
    subscriptionPriceId: String,
    accountId: String,
    slug: String,
    billingDef: {
      type: Array,
      default: [],
    },
    addressDef: {
      type: Array,
      default: [],
    },
    ledgerData: Object,
  },

  components: {
    AppLayout,
    DxDateBox,
    DxButton,
    DxButtonTypes,
    BsOnBoardForm,
    DxScrollView,
  },
  data() {
    return {};
  },
  methods: {
    saveRecord() {
      let recordData = this.$refs.onboardformRenderer.formData;
      // let altAttendanceUrl = route("attendances.makealtattendance", this.slug);
      let altAttendanceUrl = "/" + this.slug + "/attendances/makealtattendance";

      //this.$inertia.post('/'+this.moduleRoute, this.$refs.formRenderer.formData)

      // console.log("SYNC CRM CALLING", recordData);
      this.$inertia.post(altAttendanceUrl, recordData);
    },
  },
  mounted() {},
};
</script>
  